import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { SharesPage } from "@/features/vault/components/shares-page";

/**
 * Secrets shared with me (envelopes sealed to my public key). Behind the
 * gate: opening them requires my private key in memory.
 */
function SharesRoutePage() {
  return (
    <VaultGate>
      <SharesPage />
    </VaultGate>
  );
}

export const sharesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/shares",
  component: SharesRoutePage,
});
